import { baseApi } from '@shared/utils/api/configs/rtkBaseQueryDemo';

import {
  getInvoiceHistory,
  getInvoiceManual,
  getInvoiceOutstanding,
  getInvoiceOutstandingTotal,
  getInvoicePdf,
  getInvoiceReceipt,
  getPublicInvoiceInstitutions,
  getPublicInvoiceManual,
  getPublicInvoiceReceipt,
  submitInvoiceReceiptEmail,
  submitPublicInvoiceReceiptEmail,
} from './endpoints';
import { INVOICE_OUTSTANDING_TOTAL } from './endpoints/getAllClusterBills';
import { INVOICE_HISTORY } from './endpoints/getHistoryBills';
import { INVOICE_MANUAL } from './endpoints/getManualBill';
import { INVOICE_OUTSTANDING } from './endpoints/getOutstandingBills';
import { PUBLIC_INVOICE_RECEIPT } from './endpoints/getPublicReceiptPdf';
import { INVOICE_RECEIPT } from './endpoints/getReceiptPdf';

export const billsApi = baseApi
  .injectEndpoints({
    endpoints: (builder) => ({
      getInvoiceOutstandingTotal: getInvoiceOutstandingTotal(builder),
      getPublicInvoiceInstitutions: getPublicInvoiceInstitutions(builder),
      getInvoicePdf: getInvoicePdf(builder),
      getInvoiceHistory: getInvoiceHistory(builder),
      getInvoiceManual: getInvoiceManual(builder),
      getInvoiceOutstanding: getInvoiceOutstanding(builder),
      getPublicInvoiceManual: getPublicInvoiceManual(builder),
      getPublicInvoiceReceipt: getPublicInvoiceReceipt(builder),
      getInvoiceReceipt: getInvoiceReceipt(builder),
      submitPublicInvoiceReceiptEmail: submitPublicInvoiceReceiptEmail(builder),
      submitInvoiceReceiptEmail: submitInvoiceReceiptEmail(builder),
    }),
  })
  .enhanceEndpoints({
    addTagTypes: [
      INVOICE_OUTSTANDING_TOTAL,
      INVOICE_OUTSTANDING,
      INVOICE_HISTORY,
      INVOICE_MANUAL,
      INVOICE_RECEIPT,
      PUBLIC_INVOICE_RECEIPT,
    ],
  });

export const {
  useGetInvoiceOutstandingTotalQuery,
  useGetPublicInvoiceInstitutionsQuery,
  useGetInvoiceHistoryQuery,
  useGetInvoiceOutstandingQuery,
  useLazyGetInvoicePdfQuery,
  useLazyGetInvoiceManualQuery,
  useLazyGetPublicInvoiceManualQuery,
  useLazyGetPublicInvoiceReceiptQuery,
  useLazyGetInvoiceReceiptQuery,
  useSubmitPublicInvoiceReceiptEmailMutation,
  useSubmitInvoiceReceiptEmailMutation,
} = billsApi;
